import { apiFetch } from "../api";
import { BASE_URL as u } from "../../commonUrls";

const BASE_URL = `${u}/planner/today`;

export const getTodaySummary = async (days = 15) => {
  const res = await apiFetch(`${BASE_URL}?days=${days}`);
  if (!res.ok) return { urgent: [], reminders: [], payments: [] };
  return res.json();
};

export const updatePlannerStatus = async (id, status) => {
  const res = await apiFetch(`${u}/planner/${id}/status`, {
    method: "PATCH",
    body: JSON.stringify({ status }),
  });
  return res.json();
};
